<template>
  <CMSContext
    v-if="context && !isWebview"
    v-bind="context"
    :cms-page-id="data?.id"
  />

  <!-- name is a reserved NuxtPage prop https://nuxt.com/docs/api/components/nuxt-page#props -->
  <NuxtPage
    v-if="data && isSpecificLayout"
    v-bind="omit(data, ['name'])"
    data-test="specific-layout"
  />

  <DefaultLayout
    v-if="data && !isSpecificLayout"
    v-bind="data"
    data-test="default-layout"
    :isWebview
    :simpleLayout
  />
</template>

<script lang="ts" setup>
import CMSContext from '@backmarket/nuxt-layer-cms/CMSContext.vue'
import { omit } from '@backmarket/utils/object/omit'

import { useIsWebview } from '~/scopes/webviews/useIsWebview'

import { useCMSHead } from './composables/useCMSHead'
import { useFetchCMSPageContent } from './composables/useFetchCMSPageContent'
import { useFetchFallbackOnError } from './composables/useFetchFallbackOnError'
import { useFetchPageContext } from './composables/useFetchPageContext'
import { useHandleFetchError } from './composables/useHandleFetchError'
import { useHandleIncorrectRouteParams } from './composables/useHandleIncorrectRouteParams'
import { useIsSpecificLayout } from './composables/useIsSpecificLayout'
import { usePreloadFirstCarouselImage } from './composables/usePreloadFirstCarouselImage'
import DefaultLayout from './layout/Default.vue'

const { simpleLayout = false } = defineProps<{ simpleLayout?: boolean }>()

const fetchFallbackOnError = useFetchFallbackOnError()

const { data, error } = await useFetchCMSPageContent({
  fetchFallbackOnError,
})

usePreloadFirstCarouselImage(data)
useHandleFetchError(error)
useHandleIncorrectRouteParams(data)
useCMSHead(data)
const isSpecificLayout = useIsSpecificLayout(data)
const context = useFetchPageContext({ content: data.value })

const isWebview = useIsWebview()
</script>
